export default {
  slow: [
    "2g", "3g"
  ],
  fast: [
    "4g", "5g"
  ]
}
